import React from 'react';
import Backend from '../../../../Layouts/Backend';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import Summary from './Summary';
import Chart from './Chart';
import Details from './Details';
import qs from 'qs';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../../../actions/report.actions';
import { configureActions } from '../../../../../actions/configure.action';
import helper from '../../../../../utils/helper';

function SDResult({ configure, ...props }) {
  const [activeTab, setActiveTab] = React.useState('summary');
  const { groupHours } = helper.parseQueryString(props.location.search) || '1';
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const [selected, setSelected] = React.useState({
    key: [],
    row: {},
  });
  React.useEffect(() => {
    const { groupId, sensorIds, fromDate, toDate, groupHours } = qs.parse(
      props.location.search,
      {
        ignoreQueryPrefix: true,
      },
    );
    async function getSummary() {
      await props.reportActions.getStatisticsSummary({
        sensorIds,
        fromDate,
        toDate,
      });
    }
    async function getChart() {
      await props.reportActions.getStatisticsChart(selected.row.sensorId, {
        fromDate,
        toDate,
        groupHours,
      });
    }
    async function getDetails() {
      await props.reportActions.getStatisticsDetails(selected.row.sensorId, {
        fromDate,
        toDate,
        groupHours,
      });
    }
    async function getGroup() {
      await props.configureActions.getSpecificGroup(groupId);
    }
    switch (activeTab) {
      case 'summary':
        getSummary();
        getGroup();
        break;
      case 'chart':
        getChart();
        break;
      default:
        getDetails();
        break;
    }
  }, [activeTab]);
  return (
    <Backend title={`Statistics Detail Result: ${configure.group.name || ''}`}>
      <div className="content-inner">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames('btn', { active: activeTab === 'summary' })}
              onClick={() => toggle('summary')}
            >
              Summary
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames('btn', { active: activeTab === 'chart' })}
              onClick={() => toggle('chart')}
              disabled={!selected.key.length}
            >
              Chart
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames('btn', { active: activeTab === 'details' })}
              onClick={() => toggle('details')}
              disabled={!selected.key.length}
            >
              Details
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab} style={{ paddingTop: 15 }}>
          <TabPane tabId="summary">
            <Summary onSelectRow={(selected) => setSelected(selected)} />
          </TabPane>
          <TabPane tabId="chart" id="statistics-details-chart-tab">
            {activeTab === 'chart' && (
              <Chart
                sensorId={selected.row.sensorId}
                timeRange={props.timeRange}
              />
            )}
          </TabPane>
          <TabPane tabId="details">
            {activeTab === 'details' && <Details groupHours={groupHours} />}
          </TabPane>
        </TabContent>
      </div>
    </Backend>
  );
}

function mapStateToProps(state) {
  return {
    report: state.report,
    configure: state.configure,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    reportActions: bindActionCreators(
      Object.assign({}, reportActions),
      dispatch,
    ),
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SDResult);
